
/**
 * @export
 * @enum {string}
 */
export enum Role {
    ROLE_UDEDT_ADMIN = 'ROLE_UDEDT_ADMIN',
    ROLE_UDEDT_REVIEWER = 'ROLE_UDEDT_REVIEWER',
    ROLE_UDEDT_APPROVER = 'ROLE_UDEDT_APPROVER',
    ROLE_UDEDT_API = 'ROLE_UDEDT_API'
}